import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

/**
 * OutlinedSelect - A reusable, accessible, and standardized dropdown component for MUI v5.
 *
 * Props:
 * - label: string (required)
 * - labelId: string (optional, autogenerated if not provided)
 * - id: string (optional, autogenerated if not provided)
 * - value: any (required)
 * - onChange: function (required)
 * - children: MenuItem elements (required)
 * - fullWidth: boolean (optional)
 * - className: string (optional)
 * - ...rest: any other Select props
 */
const OutlinedSelect = ({
	label,
	labelId,
	id,
	value,
	onChange,
	children,
	fullWidth = false,
	className,
	...rest
}) => {
	// Generate unique IDs if not provided
	const safeLabelId = labelId || `${label.replace(/\s+/g, '-').toLowerCase()}-label`;
	const safeId = id || `${label.replace(/\s+/g, '-').toLowerCase()}-select`;

	return (
		<FormControl variant="outlined" fullWidth={fullWidth} className={className}>
			<InputLabel id={safeLabelId}>{label}</InputLabel>
			<Select
				labelId={safeLabelId}
				id={safeId}
				label={label}
				value={value}
				onChange={onChange}
				{...rest}
			>
				{children}
			</Select>
		</FormControl>
	);
};

export default OutlinedSelect;
